var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCruises = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Sea-Transport-Cruiser--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Sea Transport Cruiser Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.1 20a0.24 0.24 0 0 0 0.22 0 2.62 2.62 0 0 1 1 -0.08c0.58 0.08 1.49 -0.68 1.84 -1.1a2.54 2.54 0 0 1 2 -0.93 2.49 2.49 0 0 1 2.12 1.17 2 2 0 0 0 1.41 0.83 2.64 2.64 0 0 0 1.83 -1 2.6 2.6 0 0 1 2 -1 2.51 2.51 0 0 1 2.26 1.42 1.17 1.17 0 0 0 1 0.58 1.77 1.77 0 0 0 1.4 -0.8 2.43 2.43 0 0 1 2.14 -1.2 2.52 2.52 0 0 1 2.13 1.17s0.51 0.76 1.15 0.82a0.23 0.23 0 0 0 0.23 -0.12 8.26 8.26 0 0 0 1.2 -3.7 1.25 1.25 0 0 0 -1.25 -1.34h-5.3a0.25 0.25 0 0 1 -0.25 -0.22 9.74 9.74 0 0 0 -1 -3.44 4.92 4.92 0 0 0 -4.38 -2.59H11a0.25 0.25 0 0 1 -0.25 -0.25V6a0.5 0.5 0 0 0 -0.5 -0.5h-2a0.5 0.5 0 0 0 -0.5 0.5v2.27a0.25 0.25 0 0 1 -0.25 0.25H5a0.25 0.25 0 0 1 -0.25 -0.25V6a0.5 0.5 0 0 0 -0.5 -0.5h-2a0.5 0.5 0 0 0 -0.5 0.5v2.27a0.25 0.25 0 0 1 -0.25 0.25H1a1 1 0 0 0 0 2h10.79a2.89 2.89 0 0 1 2.6 1.5 8 8 0 0 1 0.78 2.47 0.22 0.22 0 0 1 -0.06 0.19 0.25 0.25 0 0 1 -0.19 0.09h-1.77a1.72 1.72 0 0 0 -1.49 0.88 0.27 0.27 0 0 1 -0.22 0.12H0.75a0.76 0.76 0 0 0 -0.75 0.75v3.29a0.26 0.26 0 0 0 0.1 0.19Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.4 19.11 -0.01 0 0.01 0z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.53 3.1 0.36 -0.25a2.32 2.32 0 0 1 1.21 -0.33 2.39 2.39 0 0 1 1.9 0.83 1 1 0 0 0 1.41 0.11 1 1 0 0 0 0.11 -1.41 4.52 4.52 0 0 0 -5.71 -0.89l-0.41 0.28a1.31 1.31 0 0 1 -1.66 -0.21 1 1 0 0 0 -1.4 -0.09 1 1 0 0 0 -0.09 1.41 3.37 3.37 0 0 0 4.28 0.55Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 13.02a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 13.02a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 22.28a1 1 0 0 0 -1.12 -0.86c-1.63 0.22 -2.74 -1.5 -2.75 -1.51a1 1 0 0 0 -1.71 0 3.3 3.3 0 0 1 -2.68 1.51A2.74 2.74 0 0 1 13.39 20a1 1 0 0 0 -1.71 -0.17 4.16 4.16 0 0 1 -3 1.6A3.48 3.48 0 0 1 6 19.91a1.05 1.05 0 0 0 -1.64 -0.1s-1.53 1.87 -3.2 1.65a1 1 0 0 0 -0.26 2 3.48 3.48 0 0 0 0.55 0 5.75 5.75 0 0 0 3.65 -1.57 5.14 5.14 0 0 0 3.58 1.53 5.72 5.72 0 0 0 3.7 -1.42 4.51 4.51 0 0 0 3.35 1.46A5.12 5.12 0 0 0 19.28 22a4.64 4.64 0 0 0 3.85 1.41 1 1 0 0 0 0.87 -1.13Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCruises);
export default ForwardRef;